var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.Utilities = OCS.Classes.Utilities || {};
OCS.Functions = OCS.Functions || {};
// Requires OCS.Classes.Utilities.base and OCS.Interfaces.Utilities.calculations
OCS.Functions.define_color_utilities = function () {
    return new Class({
        Implements: [new Class(OCS.Interfaces.Utilities.base), new Class(OCS.Interfaces.Utilities.calculations), new Class(OCS.Interfaces.Utilities.color)]
    });
};
OCS.Classes.Utilities.color = OCS.Functions.define_color_utilities();
